<router-outlet></router-outlet>
<app-loader *ngIf="display_Loader" ></app-loader>
<!-- <app-social-channel></app-social-channel> -->
<!-- <app-chatgpt-chatbot></app-chatgpt-chatbot> -->
